import { usePagination } from '@material-ui/lab/Pagination';
import React from 'react';

import Chevron from '@/components/icons/Chevron.svg';
import Link from '@/components/switchback/Link/Link';

interface IPagination {
  currentPage: number;
  totalPages: number;
  categorySlug: string;
}

const BlogPaginationCarousel: React.FC<IPagination> = ({
  currentPage,
  totalPages,
  categorySlug,
}) => {
  const { items } = usePagination({
    count: totalPages,
    page: currentPage,
  });

  if (totalPages <= 1) {
    return <div />;
  }

  return (
    <ul className="flex items-center justify-center text space-x-2 lg:space-x-1">
      {items.map(({ page, type, selected, ...item }, index) => {
        let children = null;

        if (type === 'start-ellipsis' || type === 'end-ellipsis') {
          children = '…';
        } else if (type === 'page') {
          children = (
            <Link legacy href={`/blog/category/${categorySlug}/page/${page}`}>
              <a
                {...item}
                className={`inline-flex items-center justify-center w-6 h-6 lg:w-8 lg:h-8 text-gray-900 rounded-full hover:bg-gray-100 ${
                  selected
                    ? 'bg-green-800 text-white hover:bg-green-900'
                    : 'text-gray-900 hover:bg-gray-100'
                }`}>
                {page}
              </a>
            </Link>
          );
        } else if (type === 'previous') {
          children = previous(page, categorySlug);
        } else if (type === 'next') {
          children = next(page, totalPages, categorySlug);
        }

        return <li key={index}>{children}</li>;
      })}
    </ul>
  );
};

const previous = (page: number, categorySlug: string) => {
  const isNext = false;
  if (page > 1) {
    return nextPreviousActiveButton(page, categorySlug, isNext);
  } else {
    return nextPreviousDisalbedButton(isNext);
  }
};

const next = (page: number, totalPages: number, categorySlug: string) => {
  const isNext = true;
  if (page < totalPages) {
    return nextPreviousActiveButton(page, categorySlug, isNext);
  } else {
    return nextPreviousDisalbedButton(isNext);
  }
};

const nextPreviousActiveButton = (page: number, categorySlug: string, isNext: boolean) => (
  <Link
    legacy
    href="/blog/category/[categorySlug]/page/[categoryPageId]"
    as={`/blog/category/${categorySlug}/page/${Number(page)}`}>
    <a className="flex items-center w-6 h-6 lg:w-8 lg:h-8 text-primary-500">
      <span
        className={`inline-block stroke-current transform ${isNext ? 'rotate-0' : 'rotate-180'}`}>
        <Chevron />
      </span>
    </a>
  </Link>
);

const nextPreviousDisalbedButton = (isNext: boolean) => (
  <span className="flex items-center w-6 h-6 text-gray-500 lg:w-8 lg:h-8">
    <span className={`inline-block stroke-current transform ${isNext ? 'rotate-0' : 'rotate-180'}`}>
      <Chevron />
    </span>
  </span>
);

export default BlogPaginationCarousel;
